import React from 'react';


const CellPlaceholder = React.memo(() => {
	return <td className="py-2 px-1">
		<div className="w-full h-3.5 bg-gray-200 rounded-md"></div>
	</td>;
});

export default CellPlaceholder;